import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import EditIcon from "@material-ui/icons/Edit";
import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import FormLabel from "@mui/material/FormLabel";
import Alert from "@mui/material/Alert";
import FormGroup from "@mui/material/FormGroup";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";

import Hosts from "./Hosts";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditCred = (props) => {
  window.sessionStorage.setItem("ScheID", props.ScheID);

  const [state, setState] = React.useState({
    name: "",
    cron_expression: "",
    delete_id: "",
    errormessage: "",
  });

  const [userlist, setusers] = useState([]);

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  useEffect(() => {
    const ScheID = props.ScheID;
    fetch(`${process.env.REACT_APP_API_URL}/api/schedule/${ScheID}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setusers(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, [props.CredID]);

  const handleSubmitClick = (e) => {
    e.preventDefault();
    const data = {
      name: state.name,
      cron_expression: state.cron_expression,
    };
    const ScheID = props.ScheID;
    fetch(`${process.env.REACT_APP_API_URL}/api/schedule/${ScheID}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [open, setOpen] = React.useState(false);
  const toggle = () => setOpen(!open);

  const [templist, settemplist] = React.useState([[]]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/organizationtemplateslist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          settemplist(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [hostlist, setHostlist] = useState([]);

  const handleProfileChange = (e) => {
    const { id, value } = e.target;
    var osValue;
    templist.map((val) => {
      if (parseInt(val.id) === parseInt(value)) {
        osValue = val.os_type;
      }
    });
    fetch(
      `${process.env.REACT_APP_API_URL}/api/organizationseperateoshostlist/${osValue}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setHostlist(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  return (
    <>
      <IconButton
        title="Edit"
        aria-label="edit"
        id="edit"
        style={{ padding: "0px", color: "#6b6f6b" }}
      >
        <EditIcon fontSize="small" onClick={toggle} />
      </IconButton>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <div>
            {state.errorMessage && (
              <Alert color="danger" isOpen={visible} toggle={onDismiss}>
                {" "}
                {state.errorMessage}{" "}
              </Alert>
            )}
          </div>
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "810",
              color: "rgb(48, 68, 115)",
              fontFamily: "sans-serif",
              lineHeight: "4.5rem",
            }}
          >
            EDIT SCHEDULE
          </h2>

          <FormGroup style={{ marginBottom: "2rem" }}>
            <FormLabel htmlFor="name">
              <strong>Name</strong>
            </FormLabel>
            <TextField
              htmlFor="name"
              placeholder={userlist.name}
              id="name"
              className="form-control"
              variant="outlined"
              size="small"
              fullwidth
              value={state.name}
              onChange={handleChange}
              type="text"
              name="name"
              fullWidth
            />
          </FormGroup>
          <FormGroup style={{ marginBottom: "2rem" }}>
            <FormLabel htmlFor="cron_expression">
              <strong>Cron Expression</strong>
            </FormLabel>
            <TextField
              htmlFor="cron_expression"
              placeholder={userlist.cron_expression}
              id="cron_expression"
              className="form-control"
              variant="outlined"
              size="small"
              fullwidth
              value={state.cron_expression}
              onChange={handleChange}
              type="text"
              name="cron_expression"
              fullWidth
            />
          </FormGroup>
          <FormGroup>
            <FormLabel htmlFor="cron_expression">
              <strong>Profile</strong>
            </FormLabel>
            <TextField
              type="select"
              id="temp_id"
              className="form-control"
              value={state.temp_id}
              name="temp_id"
              onChange={handleProfileChange}
              placeholder="-- Select the Profile --"
              variant="outlined"
              size="small"
              select
              SelectProps={{ native: true }}
              fullWidth
            >
              <option>-- Select the Profile --</option>
              {templist.map((templist) => {
                return (
                  <React.Fragment>
                    <option value={templist.id}>{templist.name}</option>
                  </React.Fragment>
                );
              })}
            </TextField>
          </FormGroup>
          <br />
          <FormGroup>
            <FormLabel htmlFor="cron_expression">
              <strong>Hosts</strong>
            </FormLabel>
                  
            <Hosts hostlist={hostlist} setState={setState} />
          </FormGroup>
          <br />
        </DialogContent>
        <DialogActions>
          <button
            className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={toggle}
          >
            Cancel
          </button>
          <button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={handleSubmitClick}
          >
            Update
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditCred;